var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGemFullMode = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  d: "M15 5a3 3 0 0 1 2.826 4H19a3 3 0 1 1 0 6h-1.174A2.993 2.993 0 0 1 15 19H6a3 3 0 1 1 0-6h1.174A3 3 0 0 1 7 12c0-.351.063-.687.174-1H6a3 3 0 0 1 0-6zM6 15a1 1 0 1 0 0 2h9a1 1 0 1 0 0-2zm4-4a1 1 0 1 0 0 2h9a1 1 0 1 0 0-2zM6 7a1 1 0 0 0 0 2h9a1 1 0 1 0 0-2z"
})));
export default SvgGemFullMode;